import { onBeforeUnmount, onMounted, ref } from "vue";
import { GraphQLClient } from "graphql-request";

const url =
  `${globalThis.Smart.env.BASE_URL}/${globalThis.Smart.env.GRAPHQL_API}`;

const fetcher = (query) => {
  const $store = globalThis.$vm.$store;
  if (!$store.getters.isAuthenticated) {
    throw new Error("Unauthenticated");
  }
  // Autenticação via cookie de sessão (proxy same-origin do BFF)
  const client = new GraphQLClient(url, { credentials: "same-origin" });
  return client.request(query);
};

const configOptions = {
  dedupingInterval: 250,
};

export const useSWR = (key = "", options = configOptions) => {
  const data = ref();
  const error = ref();
  const timeout = ref();

  const fetchData = async () => {
    try {
      const response = await fetcher(key);
      data.value = response;
    } catch (e) {
      data.value = null;
      error.value = e?.message;
    }
  };

  const handleFetch = () => {
    clearTimeout(timeout.value);
    timeout.value = setTimeout(() => {
      fetchData();
    }, options?.dedupingInterval ?? 250);
  };

  onMounted(() => {
    handleFetch();
    globalThis.addEventListener("focus", handleFetch, false);
  });

  onBeforeUnmount(() => {
    clearTimeout(timeout.value);
    globalThis.removeEventListener("focus", handleFetch, false);
  });

  return { data, error };
};
